import { Component, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-info-card',
  templateUrl: './info-card.component.html',
  styleUrls: ['./info-card.component.css']
})
export class InfoCardComponent {
  @Input() title = '';
  @Input() value: string | number = '';
  @Input() change: string = ''; // e.g., "+12%"
  @Input() subtext = '';
  @Input() changePositive = true;
  @Input() chartSvgPath = ''; // optional mini chart line path
}
